module.exports = function(posts) {
	'use strict'
	posts.directive('tagsDir',tagsDir);
	tagsDir.$inject=[];
	function tagsDir() {
		return {
			template: require('./partial/tags.html'),
			controller:'tagsController',
			controllerAs:'vmt',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/tags/js/directive/tagsDirective.js
// module id = 570
// module chunks = 0